// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3JZMi","bigColWidth":"Table_bigColWidth__3DPIf","biggerColWidth":"Table_biggerColWidth__3WsDX","row":"Table_row__AlLj_","col":"Table_col__7OcCk"};